import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import * as React from "react";
export function joinWith(separator) {
    if (!separator) {
        throw new Error("[helpers.joinWith] A separator must be specified!");
    }
    return function joinWithSeparator(acc, part, i) {
        var clonedPart = React.cloneElement(part, _object_spread_props(_object_spread({}, part.props), {
            key: i
        }));
        return acc.length ? _to_consumable_array(acc).concat([
            separator,
            clonedPart
        ]) : [
            clonedPart
        ];
    };
}
